import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';

import Header from './components/Header';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import FloatingCTA from './components/FloatingCTA';

import HomePage from './pages/HomePage';
import AltAnsigtsterapiPage from './pages/AltAnsigtsterapiPage';
import KropsterapiPage from './pages/KropsterapiPage';
import HealingmassagePage from './pages/HealingmassagePage';
import HotstoneMassagePage from './pages/HotstoneMassagePage';
import TarotkortterapiPage from './pages/TarotkortterapiPage';
import SpirituelleBoegerPage from './pages/SpirituelleBoegerPage';
import ForedragPage from './pages/ForedragPage';
import OmPage from './pages/OmPage';
import KontaktPage from './pages/KontaktPage';
import PraestindensVejKapitelPage from './pages/PraestindensVejKapitelPage';
import NotFoundPage from './pages/NotFoundPage';
import ForbiddenPage from './pages/ForbiddenPage';

export default function App() {
  return (
    <HelmetProvider>
      <ScrollToTop />
      <div className="min-h-screen flex flex-col bg-[#faf5f9] text-[#1f142e]">
        <Header />
        <main className="flex-1">
          <Routes>
            {/* Primary Navigation Pages */}
            <Route path="/" element={<HomePage />} />
            <Route path="/alt-ansigtsterapi" element={<AltAnsigtsterapiPage />} />
            <Route path="/kropsterapi" element={<KropsterapiPage />} />
            <Route path="/healingmassage" element={<HealingmassagePage />} />
            <Route path="/hotstone-massage" element={<HotstoneMassagePage />} />
            <Route path="/tarotkortterapi" element={<TarotkortterapiPage />} />
            <Route path="/spirituelle-boeger" element={<SpirituelleBoegerPage />} />
            <Route path="/spirituelle-boeger/praestindens-vej/foerste-kapitel" element={<PraestindensVejKapitelPage />} />
            <Route path="/foredrag" element={<ForedragPage />} />
            <Route path="/om-os" element={<OmPage />} />
            <Route path="/kontakt" element={<KontaktPage />} />

            {/* Aliases & Direct compatibility links */}
            <Route path="/tarotterapi" element={<Navigate to="/tarotkortterapi" replace />} />
            <Route path="/om-ibjerget" element={<Navigate to="/om-os" replace />} />
            <Route path="/spirituelle-boeger-og-kunst" element={<Navigate to="/spirituelle-boeger" replace />} />
            <Route path="/forlaget-golden-eagle" element={<Navigate to="/spirituelle-boeger" replace />} />
            <Route path="/praestindens-vej-foerste-kapitel" element={<Navigate to="/spirituelle-boeger/praestindens-vej/foerste-kapitel" replace />} />

            {/* Udlejning fjernet – omdirigeres til Spirituelle bøger og kunst */}
            <Route path="/lej-ibjerget" element={<Navigate to="/spirituelle-boeger" replace />} />
            <Route path="/ibjerget-som-kursussted-for-andre-aktoerer" element={<Navigate to="/spirituelle-boeger" replace />} />

            {/* Ældre undersider og redirects */}
            <Route path="/shamanistisk-lederuddannelse" element={<Navigate to="/om-os" replace />} />
            <Route path="/wiccagruppen-hvide-ravn" element={<Navigate to="/om-os#lone" replace />} />
            <Route path="/wicca" element={<Navigate to="/foredrag" replace />} />
            <Route path="/arrangementer-kalender" element={<Navigate to="/foredrag" replace />} />
            <Route path="/team/:slug" element={<Navigate to="/om-os" replace />} />

            {/* Error pages */}
            <Route path="/403" element={<ForbiddenPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </main>
        <Footer />
        <FloatingCTA />
      </div>
    </HelmetProvider>
  );
}
